@if (dashboard$ | async; as dashboard) {
  <div [ngClass]="['px-3 flex flex-col gap-3', verticalPadding ? 'py-3' : '']"
    id="catalog_dashboard_wrp_prepared-queries">
    <ng-container
    *ngTemplateOutlet="welcomeText; context: { content: getTranslatedLabel(dashboard.welcomeTextAbove) }"></ng-container>
    <ng-content></ng-content>
    <ng-container
    *ngTemplateOutlet="welcomeText; context: { content: getTranslatedLabel(dashboard.welcomeTextUnder) }"></ng-container>
  </div>
}

<ng-template #welcomeText let-content="content">
  @if (content) {
    <mat-card>
      <mat-card-content [innerHTML]="content" class="welcome-container"></mat-card-content>
    </mat-card>
  }
</ng-template>
